import runimg from './images/running.gif';
import delimg from './images/delayed.gif';
import comimg from './images/compl.gif';
import SideBar from './sidebar';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { findByTestId } from '@testing-library/dom';
function Dashboard()
{
    let [cdata,setCData]=useState([]);
    let [ddata,setDData]=useState([]);
    let [rdata,setRData]=useState([]);
    function setDates()
    {
        let d=new Date();
        let end=(d.getYear()+1900)+"-"+(d.getMonth()+1<10?"0"+(d.getMonth()+1):(d.getMonth()+1))+"-"+(d.getDate()<10?"0"+d.getDate():d.getDate());
        let d1=new Date();        
        d1.setMonth(d1.getMonth()-1);
        let start=(d1.getYear()+1900)+"-"+(d1.getMonth()+1<10?"0"+(d1.getMonth()+1):(d1.getMonth()+1))+"-"+(d1.getDate()<10?"0"+d1.getDate():d1.getDate());                
        document.getElementById("datestart").value=start;
        document.getElementById("dateend").value=end;
    }
    function getData(event)
    {
        let json=JSON.stringify({start:document.getElementById("datestart").value,end:document.getElementById("dateend").value});
        let config={headers:{"Content-Type":"application/json",}};
        axios.post(process.env.REACT_APP_APIURL+"summary.php",json).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                let arr=reply.data.data;
                setCData(arr.filter((e)=>e.status=="Completed"));
                setDData(arr.filter((e)=>e.status=="Delayed"));
                setRData(arr.filter((e)=>e.status=="Running"));                
            }
        });
    }    
    function getDownloadURL(sid,rtype)
    {
        return(
            <a href={process.env.REACT_APP_APIURL+"download.php?tbl=smp&fl="+rtype+"&id="+sid}>Download</a>
        );
    }
    useEffect(()=>
    {
        setDates(); 
        getData();  
    },[]);
    return(   
       
        <div className="container">
            <div className="row">
                <div className="col-12 p-3">
                    <div className="border shadow rounded-3 p-3">
                        <div className='row'>
                            <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12'><img src={runimg} style={{width:'40px'}} /> <span className='text-primary h5'>Running Project</span></div>
                            <div className='col-xxl-9 col-xl-9 col-lg-9 col-md-8 col-sm-7 col-12 text-end'><input type="date" id="datestart" onChange={getData} style={{border:'solid 1px gray',fontSize:'12px'}} className='rounded-2 p-1' /> - <input type="date" id="dateend" onChange={getData} style={{border:'solid 1px gray',fontSize:'12px'}} className='rounded-2 p-1' /></div>
                        </div>
                        <hr/>     
                        <div style={{overflow:"auto"}}>                 
                            <table className='table table-bordered table-striped'>
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Sample</th>
                                        <th>Test</th>
                                        <th>Client</th>
                                        <th>Receiving Date</th>
                                        <th>Delivery Date</th>
                                        <th>TRF File</th>
                                        <th>Report File</th>
                                        <th>Raw Data File</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rdata.map((e,i)=>
                                        <tr>
                                            <td>{i+1}</td>
                                            <td>{e.sname}</td>
                                            <td>{e.tname}</td>
                                            <td>{e.cname}</td>
                                            <td>{e.rdate}</td>
                                            <td>{e.ddate}</td>
                                            <td>{(e.trftype==null ||e.trftype=="")?"No File":getDownloadURL(e.sid,"trf")}</td>
                                            <td>{(e.reporttype==null ||e.reporttype=="")?"No File":getDownloadURL(e.sid,"rpt")}</td>
                                            <td>{(e.rawtype==null ||e.rawtype=="")?"No File":getDownloadURL(e.sid,"raw")}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>                    
                </div>
                <div className="col-12 p-3">
                    <div className="border shadow rounded-3 p-3">
                        <div className='row'>
                            <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12'><img src={delimg} style={{width:'40px'}} /> <span className='text-danger h5'>Delayed Project</span></div>
                        </div>
                        <hr/>    
                        <div style={{overflow:"auto"}}>                  
                            <table className='table table-bordered table-striped'>
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Sample</th>
                                        <th>Test</th>
                                        <th>Client</th>
                                        <th>Receiving Date</th>
                                        <th>Delivery Date</th>
                                        <th>TRF File</th>
                                        <th>Report File</th>
                                        <th>Raw Data File</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ddata.map((e,i)=>
                                        <tr>
                                            <td>{i+1}</td>
                                            <td>{e.sname}</td>
                                            <td>{e.tname}</td>
                                            <td>{e.cname}</td>
                                            <td>{e.rdate}</td>
                                            <td>{e.ddate}</td>
                                            <td>{(e.trftype==null ||e.trftype=="")?"No File":getDownloadURL(e.sid,"trf")}</td>
                                            <td>{(e.reporttype==null ||e.reporttype=="")?"No File":getDownloadURL(e.sid,"rpt")}</td>
                                            <td>{(e.rawtype==null ||e.rawtype=="")?"No File":getDownloadURL(e.sid,"raw")}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>                 
                </div>
                <div className="col-12 p-3">
                    <div className="border shadow rounded-3 p-3">
                        <div className='row'>
                            <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12'><img src={comimg} style={{width:'40px'}} /> <span className='text-success h5'>Project Completed</span></div>
                        </div>
                        <hr/>     
                        <div style={{overflow:"auto"}}>
                            <table className='table table-bordered table-striped'>
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Sample</th>
                                        <th>Test</th>
                                        <th>Client</th>
                                        <th>Receiving Date</th>
                                        <th>Delivery Date</th>
                                        <th>TRF File</th>
                                        <th>Report File</th>
                                        <th>Raw Data File</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cdata.map((e,i)=>
                                        <tr>
                                            <td>{i+1}</td>
                                            <td>{e.sname}</td>
                                            <td>{e.tname}</td>
                                            <td>{e.cname}</td>
                                            <td>{e.rdate}</td>
                                            <td>{e.ddate}</td>
                                            <td>{(e.trftype==null ||e.trftype=="")?"No File":getDownloadURL(e.sid,"trf")}</td>
                                            <td>{(e.reporttype==null ||e.reporttype=="")?"No File":getDownloadURL(e.sid,"rpt")}</td>
                                            <td>{(e.rawtype==null ||e.rawtype=="")?"No File":getDownloadURL(e.sid,"raw")}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>                   
                </div>                
            </div>
        </div>
        
    );
}
export default Dashboard;